import React from "react";
import { Card, Box, Typography, Avatar } from "@mui/material";

const EmployeeKpiCard = ({ title, value, icon, color = "#1976d2" }) => {
  return (
 <Card
  sx={{
    position: "relative",
    borderRadius: 3,
    height: "100%",
    overflow: "hidden",
    background: "#ffffff",

    border: "1px solid #e5e9f2",

    boxShadow: `
      0px 1px 2px rgba(16, 24, 40, 0.06),
      0px 4px 10px rgba(16, 24, 40, 0.08)
    `,

    display: "flex",
    alignItems: "center",
    gap: 2.5,
    p: 2.2,
  }}
>

      {/* LEFT COLOR INDICATOR BAR */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 6,
          background: color,
        }}
      />

      {/* ICON BLOCK */}
      <Avatar
        sx={{
          width: 54,
          height: 54,
          ml: 1,

          background: color,
          color: "#fff",

          /* makes icon pop */
          boxShadow: `0 6px 14px ${color}55`,
        }}
      >
        {icon}
      </Avatar>

      {/* CONTENT */}
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: "#6b7280",
            letterSpacing: 0.3,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: 30,
            fontWeight: 700,
            color: "#111827",
            mt: 0.3,
          }}
        >
          {value}
        </Typography>
      </Box>
    </Card>
  );
};

export default EmployeeKpiCard;
